import styled from 'styled-components';

export const ActionPanelStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding: 2rem 0;
`;

export const FiltersWrapperStyled = styled.div`
  display: flex;
  gap: 2rem;
`;

export const RightSectionStyled = styled.div`
  display: flex;
  gap: 2rem;
`;
